import { combineEpics } from 'redux-observable';
import { authenticationRequestEpic } from './Authentication/AuthenticationRequestEpic';

export const userEpics = combineEpics(
  authenticationRequestEpic,
);
